<template>
  <b-row class="campaign-filter-jobs-where">

    <b-col v-bind="cols" v-if="!isEXPD8">
      <b-form-group :label="$t('jobs.labels.title')" label-for="title">
        <b-form-input id="title" :placeholder="$t('campaign-admin.placeholders.example-jobs')" v-model.trim="form.title"/>
      </b-form-group>
    </b-col>

    <b-col v-bind="cols" v-if="!departmentFromCustomField && !isEXPD8 && !isKP && !isGROWMARK">
      <b-form-group :label="$t('jobs.labels.department')" label-for="department">
        <b-form-select id="department" :disabled="!departments.length" v-model="form.department">
          <option :value="null">{{ $t('ctas.select-option') }}</option>
          <option v-for="({ id, name, icon }) in departments" :key="id" :value="id">
            <font-awesome-icon v-if="icon" :icon="icon"/>
            {{ name }}
          </option>
        </b-form-select>
      </b-form-group>
    </b-col>

    <b-col v-bind="cols" v-if="departmentFromCustomField && Array.isArray(filterCustomField('department')) && filterCustomField('department').length !== 0">
      <b-form-group :label="$t('jobs.labels.department')" label-for="department">
        <b-form-select id="department" v-model="form.department">
          <option :value="null">{{ $t('ctas.select-option') }}</option>
          <option v-for="(value, key) in filterCustomField('department')" :key="key" :value="value">{{ value }}</option>
        </b-form-select>
      </b-form-group>
    </b-col>

    <b-col v-bind="cols" v-if="!isGROWMARK && !isEXPD8 && !isVoltaTrucks && !isChalhoub">
      <b-form-group :label="$t('jobs.labels.location')" label-for="location" v-if="useLocationEnum">
        <b-form-select id="location" :disabled="filterCustomField('location').length === 0" v-model="form.location">
          <template v-slot:first><option :value="null">{{ $t('ctas.select-option') }}</option></template>
          <option v-for="(value, key) in filterCustomField('location')" :key="key" :value="value">{{ value }}</option>
        </b-form-select>
      </b-form-group>
      <b-form-group :label="$t('jobs.labels.location')" label-for="location" v-else>
        <location-search id="location" v-model="form.location"/>
      </b-form-group>
    </b-col>

    <b-col v-bind="cols" v-if="Array.isArray(filterCustomField('brand')) && filterCustomField('brand').length > 1 && !isOptiver && !isHelloFresh">
      <b-form-group :label="$t('jobs.labels.brand')" label-for="brand">
        <b-form-select id="brand" v-model="form.brand">
          <option :value="null">{{ $t('ctas.select-option') }}</option>
          <option v-for="(value, key) in filterCustomField('brand')" :key="key" :value="value">{{ value }}</option>
        </b-form-select>
      </b-form-group>
    </b-col>

    <b-col v-bind="cols" v-if="Array.isArray(filterCustomField('region')) && filterCustomField('region').length !== 0">
      <b-form-group :label="$t('jobs.labels.region')" label-for="region">
        <b-form-select id="region" v-model="form.region">
          <option :value="null">{{ $t('ctas.select-option') }}</option>
          <option v-for="(value, key) in filterCustomField('region')" :key="key" :value="value">{{ value }}</option>
        </b-form-select>
      </b-form-group>
    </b-col>

    <b-col v-bind="cols" v-if="Array.isArray(filterCustomField('district')) && filterCustomField('district').length !== 0">
      <b-form-group :label="$t('jobs.labels.district')" label-for="district">
        <b-form-select id="district" v-model="form.district">
          <option :value="null">{{ $t('ctas.select-option') }}</option>
          <option v-for="(value, key) in filterCustomField('district')" :key="key" :value="value">{{ value }}</option>
        </b-form-select>
      </b-form-group>
    </b-col>

    <b-col v-bind="cols" v-if="Array.isArray(filterCustomField('city')) && filterCustomField('city').length !== 0">
      <b-form-group :label="$t('jobs.labels.city')" label-for="city">
        <b-form-select id="city" v-model="form.city">
          <option :value="null">{{ $t('ctas.select-option') }}</option>
          <option v-for="(value, key) in filterCustomField('city')" :key="key" :value="value">{{ value }}</option>
        </b-form-select>
      </b-form-group>
    </b-col>

    <b-col v-bind="cols" v-if="Array.isArray(filterCustomField('state')) && filterCustomField('state').length !== 0">
      <b-form-group :label="$t('jobs.labels.state')" label-for="state">
        <b-form-select id="state" v-model="form.state">
          <option :value="null">{{ $t('ctas.select-option') }}</option>
          <option v-for="(value, key) in filterCustomField('state')" :key="key" :value="value">{{ value }}</option>
        </b-form-select>
      </b-form-group>
    </b-col>

    <b-col v-bind="cols" v-if="!isGROWMARK && Array.isArray(filterCustomField('country')) && filterCustomField('country').length !== 0">
      <b-form-group :label="$t('jobs.labels.country')" label-for="country">
        <b-form-select id="country" v-model="form.country">
          <option :value="null">{{ $t('ctas.select-option') }}</option>
          <option v-for="(value, key) in filterCustomField('country')" :key="key" :value="value">{{ value }}</option>
        </b-form-select>
      </b-form-group>
    </b-col>

    <b-col v-bind="cols" v-if="isRecruiterAdmin && Array.isArray(filterCustomField('postalDistrict')) && filterCustomField('postalDistrict').length !== 0">
      <b-form-group :label="$t('jobs.labels.postalDistrict')" label-for="postalDistrict">
        <b-form-select id="postalDistrict" v-model="form.postalDistrict">
          <option :value="null">{{ $t('ctas.select-option') }}</option>
          <option v-for="(value, key) in filterCustomField('postalDistrict')" :key="key" :value="value">{{ value }}</option>
        </b-form-select>
      </b-form-group>
    </b-col>

    <b-col v-bind="cols" v-if="Array.isArray(filterCustomField('workplace')) && filterCustomField('workplace').length !== 0">
      <b-form-group :label="$t('jobs.labels.workplace')" label-for="workplace">
        <b-form-select id="workplace" v-model="form.workplace">
          <option :value="null">{{ $t('ctas.select-option') }}</option>
          <option v-for="(value, key) in filterCustomField('workplace')" :key="key" :value="value">{{ value }}</option>
        </b-form-select>
      </b-form-group>
    </b-col>

    <b-col v-bind="cols" v-if="Array.isArray(filterCustomField('jobTitle')) && filterCustomField('jobTitle').length !== 0">
      <b-form-group :label="$t('jobs.labels.title')" label-for="jobTitle">
        <b-form-select id="jobTitle" v-model="form.jobTitle">
          <option :value="null">{{ $t('ctas.select-option') }}</option>
          <option v-for="(value, key) in filterCustomField('jobTitle')" :key="key" :value="value">{{ value }}</option>
        </b-form-select>
      </b-form-group>
    </b-col>

    <b-col v-bind="cols" v-if="Array.isArray(filterCustomField('activity')) && filterCustomField('activity').length !== 0">
      <b-form-group :label="$t('jobs.labels.activity')" label-for="activity">
        <b-form-select id="activity" v-model="form.activity">
          <option :value="null">{{ $t('ctas.select-option') }}</option>
          <option v-for="(value, key) in filterCustomField('activity')" :key="key" :value="value">{{ value }}</option>
        </b-form-select>
      </b-form-group>
    </b-col>

    <b-col v-bind="cols" v-if="isRecruiterAdmin && Array.isArray(filterCustomField('chain')) && filterCustomField('chain').length !== 0">
      <b-form-group :label="$t('jobs.labels.chain')" label-for="chain">
        <b-form-select id="chain" v-model="form.chain">
          <option :value="null">{{ $t('ctas.select-option') }}</option>
          <option v-for="(value, key) in filterCustomField('chain')" :key="key" :value="value">{{ value }}</option>
        </b-form-select>
      </b-form-group>
    </b-col>

    <b-col v-bind="cols" v-if="Array.isArray(filterCustomField('area')) && filterCustomField('area').length !== 0">
      <b-form-group :label="$t('jobs.labels.area')" label-for="area">
        <b-form-select id="area" v-model="form.area">
          <option :value="null">{{ $t('ctas.select-option') }}</option>
          <option v-for="(value, key) in filterCustomField('area')" :key="key" :value="value">{{ value }}</option>
        </b-form-select>
      </b-form-group>
    </b-col>

    <b-col v-bind="cols" v-if="Array.isArray(filterCustomField('company')) && filterCustomField('company').length > 1">
      <b-form-group :label="$t('jobs.labels.company')" label-for="company">
        <b-form-select id="company" v-model="form.company">
          <option :value="null">{{ $t('ctas.select-option') }}</option>
          <option v-for="(value, key) in filterCustomField('company')" :key="key" :value="value">{{ value }}</option>
        </b-form-select>
      </b-form-group>
    </b-col>

    <b-col v-bind="cols" v-if="Array.isArray(filterCustomField('jobPosition')) && filterCustomField('jobPosition').length !== 0">
      <b-form-group :label="$t('jobs.labels.jobPosition')" label-for="jobPosition">
        <b-form-select id="jobPosition" v-model="form.jobPosition">
          <option :value="null">{{ $t('ctas.select-option') }}</option>
          <option v-for="(value, key) in filterCustomField('jobPosition')" :key="key" :value="value">{{ value }}</option>
        </b-form-select>
      </b-form-group>
    </b-col>

    <b-col v-bind="cols" v-if="Array.isArray(filterCustomField('callCenter')) && filterCustomField('callCenter').length !== 0">
      <b-form-group :label="$t('jobs.labels.callCenter')" label-for="callCenter">
        <b-form-select id="callCenter" v-model="form.callCenter">
          <option :value="null">{{ $t('ctas.select-option') }}</option>
          <option v-for="(value, key) in filterCustomField('callCenter')" :key="key" :value="value">{{ value }}</option>
        </b-form-select>
      </b-form-group>
    </b-col>

    <b-col v-bind="cols" v-if="Array.isArray(filterCustomField('office')) && filterCustomField('office').length !== 0">
      <b-form-group :label="$t('jobs.labels.office')" label-for="office">
        <b-form-select id="office" v-model="form.office">
          <option :value="null">{{ $t('ctas.select-option') }}</option>
          <option v-for="(value, key) in filterCustomField('office')" :key="key" :value="value">{{ value }}</option>
        </b-form-select>
      </b-form-group>
    </b-col>

    <b-col v-bind="cols" v-if="Array.isArray(filterCustomField('organisation')) && filterCustomField('organisation').length !== 0">
      <b-form-group :label="$t('jobs.labels.organisation')" label-for="organisation">
        <b-form-select id="organisation" v-model="form.organisation">
          <option :value="null">{{ $t('ctas.select-option') }}</option>
          <option v-for="(value, key) in filterCustomField('organisation')" :key="key" :value="value">{{ value }}</option>
        </b-form-select>
      </b-form-group>
    </b-col>

    <b-col v-bind="cols">
      <b-form-group :label="$t('jobs.labels.campaign')" label-for="campaign">
        <b-form-select id="campaign" :placeholder="$t('ctas.select-campaign')"
          :options="campaignOptions" v-model="form.campaign"/>
      </b-form-group>
    </b-col>

    <b-col v-bind="cols" v-if="isRecruiterAdmin">
      <b-form-group :label="$t('jobs.labels.status')" label-for="status">
        <b-form-select id="status" :placeholder="$t('ctas.select-status')"
          :options="statusOptions" v-model="form.status"/>
      </b-form-group>
    </b-col>

  </b-row>
</template>

<script>
import LocationSearch from '@/components/misc/LocationSearch';
import { mapRoot, mapPreferences } from '@/mixins/root';

export default {
  props: {
    campaigns: {
      type: Array,
      default: null,
    },
    orientation: {
      type: String,
      default: () => 'horizontal',
      validate: layout => [ 'horizontal', 'vertical' ].includes(layout),
    },
    whereCustomFields: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: Object,
      default: null,
    },
  },
  components: {
    LocationSearch,
  },
  data: () => ({
    form: null,
  }),
  created() {
    const form = {};

    if (this.value) {
      form.title = this.value.title || null;

      if (!this.departmentFromCustomField) {
        if (this.department && this.department.id) {
          form.department = this.department.id;
        } else {
          form.department = null;
        }
      }

      if (!this.useLocationEnum) {
        form.location = this.value.locationWhere && this.value.locationWhere.id
          ? { id: this.value.locationWhere.id }
          : null;
      }

      if (Array.isArray(this.value.customFields)) {
        const location = this.value.customFields.find(({ key }) => key === 'location');
        if (this.useLocationEnum) {
          form.location = location && location.value ? location.value : null;
        }

        if (this.departmentFromCustomField) {
          const department = this.value.customFields.find(({ key }) => key === 'department');
          form.department = department && department.value ? department.value : null;
        }

        const brand = this.value.customFields.find(({ key }) => key === 'brand');
        form.brand = brand && brand.value ? brand.value : null;

        const region = this.value.customFields.find(({ key }) => key === 'region');
        form.region = region && region.value ? region.value : null;

        const district = this.value.customFields.find(({ key }) => key === 'district');
        form.district = district && district.value ? district.value : null;

        const city = this.value.customFields.find(({ key }) => key === 'city');
        form.city = city && city.value ? city.value : null;

        const country = this.value.customFields.find(({ key }) => key === 'country');
        form.country = country && country.value ? country.value : null;

        const postalDistrict = this.value.customFields.find(({ key }) => key === 'postalDistrict');
        form.postalDistrict = postalDistrict && postalDistrict.value ? postalDistrict.value : null;

        const workplace = this.value.customFields.find(({ key }) => key === 'workplace');
        form.workplace = workplace && workplace.value ? workplace.value : null;

        const jobTitle = this.value.customFields.find(({ key }) => key === 'jobTitle');
        form.jobTitle = jobTitle && jobTitle.value ? jobTitle.value : null;

        const activity = this.value.customFields.find(({ key }) => key === 'activity');
        form.activity = activity && activity.value ? activity.value : null;

        const chain = this.value.customFields.find(({ key }) => key === 'chain');
        form.chain = chain && chain.value ? chain.value : null;

        const area = this.value.customFields.find(({ key }) => key === 'area');
        form.area = area && area.value ? area.value : null;

        const company = this.value.customFields.find(({ key }) => key === 'company');
        form.company = company && company.value ? company.value : null;

        const jobPosition = this.value.customFields.find(({ key }) => key === 'jobPosition');
        form.jobPosition = jobPosition && jobPosition.value ? jobPosition.value : null;

        const callCenter = this.value.customFields.find(({ key }) => key === 'callCenter');
        form.callCenter = callCenter && callCenter.value ? callCenter.value : null;

        const office = this.value.customFields.find(({ key }) => key === 'office');
        form.office = office && office.value ? office.value : null;

        const organisation = this.value.customFields.find(({ key }) => key === 'organisation');
        form.organisation = organisation && organisation.value ? organisation.value : null;

        const state = this.value.customFields.find(({ key }) => key === 'state');
        form.state = state && state.value ? state.value : null;
      }

      form.campaign = this.value.campaigns && this.value.campaigns.id
        ? this.value.campaigns.id
        : null;

      form.status = this.value.status || 'ACTIVE';
    }

    this.form = form;
  },
  computed: {
    ...mapRoot([ 'company', 'isEnumLocation', 'isOptiver', 'isEXPD8', 'isKP', 'isRecruiterAdmin', 'isVoltaTrucks', 'isHelloFresh', 'isChalhoub', 'isGWRReferrals', 'isERM', 'isGROWMARK' ]),
    ...mapPreferences([ 'departmentFromCustomField' ]),
    cols() {
      const brands = this.filterCustomField('brand');
      if (this.orientation === 'horizontal') {
        return { cols: 12, sm: 6, md: Array.isArray(brands) && brands.length ? 4 : 3 };
      } else {
        return { cols: 12 };
      }
    },
    departments() {
      const { departments } = this.company || {};
      const options = Array.isArray(departments) ? departments : [];
      return options.sort((a, b) => a.name.localeCompare(b.name));
    },
    useLocationEnum() {
      const { handle } = this.company || {};
      return this.isEnumLocation || [ 'ashfield', 'ocadogroup', 'optiver-apac', 'gwr', 'hellofresh', 'erm' ].includes(handle);
    },
    campaignOptions() {
      return [
        { text: this.$t('ctas.select-campaign'), value: null },
        ...(Array.isArray(this.campaigns) ? this.campaigns : []).map(({ id, title }) => ({ text: title, value: id })),
      ];
    },
    statusOptions() {
      return [
        { text: 'Active', value: 'ACTIVE' },
        { text: 'Inactive', value: 'INACTIVE' },
        { text: 'Deleted', value: 'DELETED' },
      ];
    },
  },
  methods: {
    filterCustomField(key) {
      const { [key]: customField } = this.whereCustomFields || {};
      return Array.isArray(customField) ? customField : [];
    },
  },
  debounceWatch: {
    form: {
      handler(form) {
        const where = {};

        if (form.title) {
          where.title = form.title;
        }

        if (form.department && !this.departmentFromCustomField) {
          where.department = { id: form.department };
        }

        if (form.department && this.departmentFromCustomField) {
          where.customFields = (Array.isArray(where.customFields) ? where.customFields : []).concat({
            key: 'department',
            value: form.department,
          });
        }

        if (form.location) {
          if (this.useLocationEnum) {
            where.customFields = (Array.isArray(where.customFields) ? where.customFields : []).concat({
              key: 'location',
              value: form.location,
            });
          } else if (form.location && form.location.id) {
            where.locationWhere = { id: form.location.id };
          }
        }

        if (form.brand) {
          where.customFields = (Array.isArray(where.customFields) ? where.customFields : []).concat({
            key: 'brand',
            value: form.brand,
          });
        }

        if (form.region) {
          where.customFields = (Array.isArray(where.customFields) ? where.customFields : []).concat({
            key: 'region',
            value: form.region,
          });
        }

        if (form.district) {
          where.customFields = (Array.isArray(where.customFields) ? where.customFields : []).concat({
            key: 'district',
            value: form.district,
          });
        }

        if (form.city) {
          where.customFields = (Array.isArray(where.customFields) ? where.customFields : []).concat({
            key: 'city',
            value: form.city,
          });
        }

        if (form.country) {
          where.customFields = (Array.isArray(where.customFields) ? where.customFields : []).concat({
            key: 'country',
            value: form.country,
          });
        }

        if (form.postalDistrict) {
          where.customFields = (Array.isArray(where.customFields) ? where.customFields : []).concat({
            key: 'postal-district',
            value: form.postalDistrict,
          });
        }

        if (form.workplace) {
          where.customFields = (Array.isArray(where.customFields) ? where.customFields : []).concat({
            key: 'workplace',
            value: form.workplace,
          });
        }

        if (form.jobTitle) {
          where.customFields = (Array.isArray(where.customFields) ? where.customFields : []).concat({
            key: 'job-title',
            value: form.jobTitle,
          });
        }

        if (form.activity) {
          where.customFields = (Array.isArray(where.customFields) ? where.customFields : []).concat({
            key: 'activity',
            value: form.activity,
          });
        }

        if (form.chain) {
          where.customFields = (Array.isArray(where.customFields) ? where.customFields : []).concat({
            key: 'chain',
            value: form.chain,
          });
        }

        if (form.area) {
          where.customFields = (Array.isArray(where.customFields) ? where.customFields : []).concat({
            key: 'area',
            value: form.area,
          });
        }

        if (form.company) {
          where.customFields = (Array.isArray(where.customFields) ? where.customFields : []).concat({
            key: 'company',
            value: form.company,
          });
        }

        if (form.jobPosition) {
          where.customFields = (Array.isArray(where.customFields) ? where.customFields : []).concat({
            key: 'job-position',
            value: form.jobPosition,
          });
        }

        if (form.callCenter) {
          where.customFields = (Array.isArray(where.customFields) ? where.customFields : []).concat({
            key: 'call-center',
            value: form.callCenter,
          });
        }

        if (form.office) {
          where.customFields = (Array.isArray(where.customFields) ? where.customFields : []).concat({
            key: 'office',
            value: form.office,
          });
        }

        if (form.organisation) {
          where.customFields = (Array.isArray(where.customFields) ? where.customFields : []).concat({
            key: 'organisation',
            value: form.organisation,
          });
        }

        if (form.state) {
          where.customFields = (Array.isArray(where.customFields) ? where.customFields : []).concat({
            key: 'state',
            value: form.state,
          });
        }

        if (form.campaign) {
          where.campaigns = { id: form.campaign };
        }

        if (form.status && form.status !== 'ACTIVE') {
          where.status = form.status;
        }

        this.$emit('input', where);
      },
      wait: '1s',
      deep: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/campaign/FilterJobsWhere.vue